"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductType = exports.TransactionStatus = exports.RelationType = exports.OrderStatus = void 0;
var OrderStatus = /*#__PURE__*/function (OrderStatus) {
  OrderStatus["Paid"] = "paid";
  OrderStatus["Pending"] = "pending";
  OrderStatus["PendingPartialRefund"] = "pending_partial_refund";
  OrderStatus["PendingFullRefund"] = "pending_full_refund";
  OrderStatus["NoRefund"] = "cancelled_no_refund";
  OrderStatus["PartialRefund"] = "partial_refund";
  OrderStatus["FullRefund"] = "full_refund";
  OrderStatus["Error"] = "error";
  OrderStatus["Invoice"] = "invoice";
  return OrderStatus;
}(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var RelationType = /*#__PURE__*/function (RelationType) {
  RelationType["EVENT"] = "Event";
  return RelationType;
}(RelationType || (exports.RelationType = RelationType = {}));
var TransactionStatus = /*#__PURE__*/function (TransactionStatus) {
  TransactionStatus["PAID"] = "paid";
  TransactionStatus["PENDING"] = "pending";
  TransactionStatus["CANCELLED"] = "cancelled";
  TransactionStatus["DECLINED"] = "declined";
  TransactionStatus["REFUND"] = "refund";
  TransactionStatus["REFUND_PENDING"] = "refund-pending";
  TransactionStatus["REFUND_FAILED"] = "refund-failed";
  TransactionStatus["INVOICE"] = "invoice";
  return TransactionStatus;
}(TransactionStatus || (exports.TransactionStatus = TransactionStatus = {}));
var ProductType = /*#__PURE__*/function (ProductType) {
  ProductType["TICKET"] = "ticket";
  ProductType["CUSTOM"] = "custom";
  ProductType["SESSION"] = "session";
  ProductType["DONATION"] = "donation";
  return ProductType;
}(ProductType || (exports.ProductType = ProductType = {}));

